import React from "react";
import logo from './logo.svg';
import './Loading.css';

function Loading(props) {
    return(
        <div className="Loading">
        <header className="Loading-header">
          <img src={logo} className="Loading-logo" alt="logo" />
          <br/>
          <p>
            Cargando, por favor espere...
          </p>
          <a
            className="Loading-link"
            href="https://poblacion.com.co/contenido/visor-multivariable-triage-poblacional/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Volver a Poblacion.com.co
          </a>
        </header>
      </div>
    )
}

export default Loading;